export function register() {
  if ("serviceWorker" in navigator) {
    console.info("[SW] Page controller:", navigator.serviceWorker.controller ? "existing worker" : "none yet");
    navigator.serviceWorker.addEventListener("controllerchange", () => console.info("[SW] Page controller changed:", navigator.serviceWorker.controller?.scriptURL));
    navigator.serviceWorker.register("/homm3/service-worker.js", { scope: "/homm3/" })
      .then(registration => {
        if (registration.waiting) console.info("[SW] Update waiting; close all app tabs/windows to activate");
        const watchInstalling = () => {
          const worker = registration.installing;
          if (!worker) return;
          console.info("[SW] Installing worker detected");
          worker.addEventListener("statechange", () => {
            console.info("[SW] Worker state:", worker.state);
            if (worker.state === "installed" && navigator.serviceWorker.controller) console.info("[SW] Update ready; close all app tabs/windows to activate");
          });
        };
        registration.addEventListener("updatefound", watchInstalling);
        watchInstalling();
      })
      .catch(error => console.error("[SW] Registration failed:", error));
  }
}
